import { useQuery } from '@tanstack/react-query';
import { Col, Divider, Form, Select } from 'antd'
import React from 'react'
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getDiagnosis, getSymptoms } from '../../../network/encounters';
import { getComplaint } from '../../../network/complaint';

const EncounterImpression = ({t,form}) => {
    // const { data: symptoms } = useQuery({
    //     queryKey: [queryKeys.getSymptoms],
    //     queryFn: () => getSymptoms(),
    //     keepPreviousData: true,
    //   });
    const { data: complaint } = useQuery({
      queryKey: [queryKeys.getComplaint],
      queryFn: () => getComplaint(),
      keepPreviousData: true,
    });
      const { data: diagnosis } = useQuery({
        queryKey: [queryKeys.getDiagnosis],
        queryFn: () => getDiagnosis(),
        keepPreviousData: true,
      });
  return (
    <>
         <Divider orientation="left">{t.encounterimpression}</Divider>
              <Col xs={24} sm={12} md={8} lg={8}>
                <Form.Item
                  name="symptoms"
                  // name="complaints"
                  label={t.complaints}
                  // label={t.name}
                //   rules={[{ required: true, message: t.requiredSymptoms }]}
                >
                  <Select
                    placeholder={t.complaints}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLocaleLowerCase().includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? '')
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                    mode="multiple"
                    // onChange={(values) => {
                    //   console.log('values:', values);
                    // } }
                    options={complaint?.data?.map((complaint) => ({
                      value: complaint.name,
                      label: complaint.complaints,
                    }))}
                    // options={symptoms?.message?.symptoms?.map((country) => ({
                    //   value: country.name,
                    //   label: country.complaints,
                    // }))}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <Form.Item
                  name="diagnosis"
                  label={t.diagnosis}
                  // label={t.name}
                //   rules={[{ required: true, message: t.requiredDiagnosis }]}
                >
                  <Select
                    placeholder={t.diagnosis}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLocaleLowerCase().includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? '')
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                    mode="multiple"
                    options={diagnosis?.message?.diagnosis?.map((country) => ({
                      value: country.name,
                      label: country.diagnosis,
                    }))}
                  />
                </Form.Item>
              </Col>
    </>
  )
}

export default EncounterImpression